import {
  Component,
  Input,
  ChangeDetectionStrategy,
  forwardRef,
  OnInit,
} from '@angular/core'
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { TypographyComponent } from '../typography/typography.component'
import { IconComponent } from '../icon/icon.component'

@Component({
  selector: 'hyperkit-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: true,
  imports: [CommonModule, TypographyComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor, OnInit {
  @Input() label?: string
  @Input() disabled = false
  @Input() indeterminate = false
  @Input() position: 'left' | 'right' = 'right'
  @Input() checked = false

  private onChange = (value: boolean) => {}
  private onTouched = () => {}
  private formValueSet = false

  ngOnInit() {
    // Only apply initial @Input() value if not overridden by form
    if (!this.formValueSet) {
      this.onChange(this.checked) // initialize form with @Input() if needed
    }
  }

  toggleChecked(): void {
    if (this.disabled) return
    this.checked = !this.checked
    this.indeterminate = false
    this.onChange(this.checked)
    this.onTouched()
  }

  // Called by Angular Forms
  writeValue(value: boolean): void {
    this.formValueSet = true
    this.checked = value
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
}
